// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ZeevV","head":"Card_head__XGCWI","title":"Card_title__BUrVm"};